
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opportunite-business/[slug]",
      function () {
        return require("private-next-pages/opportunite-business/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opportunite-business/[slug]"])
      });
    }
  